
import React from 'react';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';

const NotFoundState: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="text-5xl mb-4">😕</div>
      <h2 className="text-xl font-medium mb-2">Receta no encontrada</h2>
      <p className="text-gray-500 mb-6">
        No pudimos encontrar esta receta. Puede que no exista en la base de datos o que la dirección sea incorrecta.
      </p>
      <div className="flex flex-col gap-3 w-full max-w-xs">
        <Button onClick={() => navigate('/recommendations')}>
          Ver todas las recetas
        </Button>
        <Button variant="outline" onClick={() => navigate(-1)}>
          Volver atrás
        </Button>
      </div>
    </div>
  );
};

export default NotFoundState;
